import { useCallback, useState } from 'react';

export const TABLE_ZOOM_MIN = 0.5;
export const TABLE_ZOOM_MAX = 1.5;
export const TABLE_ZOOM_STEP = 0.1;
export const TABLE_ZOOM_DEFAULT = 1;

export function useTableZoom(initialZoom = TABLE_ZOOM_DEFAULT) {
    const [zoomLevel, setZoomLevel] = useState(initialZoom);

    const handleZoomIn = useCallback(() => {
        setZoomLevel(prev =>
            Math.min(
                Number((prev + TABLE_ZOOM_STEP).toFixed(1)),
                TABLE_ZOOM_MAX,
            ),
        );
    }, []);

    const handleZoomOut = useCallback(() => {
        setZoomLevel(prev =>
            Math.max(
                Number((prev - TABLE_ZOOM_STEP).toFixed(1)),
                TABLE_ZOOM_MIN,
            ),
        );
    }, []);

    const handleZoomReset = useCallback(() => {
        setZoomLevel(TABLE_ZOOM_DEFAULT);
    }, []);

    const handleZoomChange = useCallback((value: number) => {
        setZoomLevel(Number(value.toFixed(1)));
    }, []);

    const canZoomIn = zoomLevel < TABLE_ZOOM_MAX;
    const canZoomOut = zoomLevel > TABLE_ZOOM_MIN;

    return {
        zoomLevel,
        handleZoomIn,
        handleZoomOut,
        handleZoomReset,
        handleZoomChange,
        canZoomIn,
        canZoomOut,
    };
}
